module.exports = "/img/_/_/_/assets/images//tabs.png?af464676df4baf5ef238d9341c57684b";